<script>
import picProfile from "@/assets/img/Unknown_Person.png";
import { dateFormat, numberWithCommas } from "@/utils";
import TransactionsTable from "@/view/components/subscriber/profile/TransactionsTable.vue";
export default {
  name: "overview",
  props: ["item"],
  components: {
    TransactionsTable
  },
  data() {
    return {
      search: ""
    };
  },
  mounted() {

  },
  computed: {
    thumbImage() {
      return picProfile;
    },
    dateSubscribed() {
      return this.item && this.item.created
        ? dateFormat(this.item.created)
        : null;
    },
    firstVisited() {
      return this.item && this.item.first_visited
        ? dateFormat(this.item.first_visited)
        : "";
    },
    lifetimeRevenue() {
      return this.item && this.item.lifetime_revenue
        ? `${numberWithCommas(this.item.lifetime_revenue.toFixed(2))}`
        : 0;
    },
    campaignRevenue() {
      return this.item && this.item.campaign_revenue
        ? `${numberWithCommas(this.item.campaign_revenue)}`
        : 0;
    },
    totalVisits() {
      return this.item && this.item.total_visits ? this.item.total_visits : 0;
    }
  }
};
</script>

<template>
  <div>
    <v-row>
      <v-col cols="12" sm="4">
        <v-card class="mx-auto rounded-lg" outlined color="basil">
          <v-list-item three-line>
            <v-list-item-content>
              <div class="text-overline mb-4">
                <span class="text-muted">First visit</span> <br />
                {{ firstVisited }}
              </div>
              <v-list-item-title class="font-weight-bold mb-1 text-uppercase">
                {{ item.customer_name }}
              </v-list-item-title>
              <v-list-item-subtitle>{{ item.email }} </v-list-item-subtitle>
              <v-list-item-subtitle v-if="item.loyalty_status"><strong>Loyalty Status:</strong> {{ item.loyalty_status }} </v-list-item-subtitle>
              <v-list-item-subtitle v-if="item.loyalty_email_preference"><strong>Email Opt In:</strong> {{ item.loyalty_email_preference }} </v-list-item-subtitle>
              <v-list-item-subtitle v-if="item.loyalty_sms_preference"><strong>SMS Opt In:</strong> {{ item.loyalty_sms_preference }} </v-list-item-subtitle>
              
            </v-list-item-content>

            <v-list-item-avatar tile size="80" color="grey">
              <img :src="thumbImage" />
            </v-list-item-avatar>
          </v-list-item>
          <!-- <v-card-actions> DISABLED TEMPORARY
            <v-btn outlined text small>
              Edit
            </v-btn>
            <v-btn outlined text small>
              Unsubscribe
            </v-btn>
            <v-btn outlined text small>
              Remove
            </v-btn>
          </v-card-actions> -->
        </v-card>
      </v-col>
      <v-col cols="12" sm="4">
        <v-card class="rounded-lg mb-5 mt-1" outlined>
          <div class="px-7 py-3">
            <span class="pr-2 opacity-70">$</span>
            <span class="pr-2 font-size-h1 font-weight-bold">{{
              lifetimeRevenue
            }}</span>
            <span class="text-primary">/&nbsp;&nbsp;LIFETIME REVENUE</span>
          </div>
        </v-card>
        <v-card class="mx-auto rounded-lg mt-5" outlined>
          <div class="px-7 py-3">
            <span class="pr-2 opacity-70">$</span>
            <span class="pr-2 font-size-h1 font-weight-bold">{{
              campaignRevenue
            }}</span>
            <span class="text-primary">/&nbsp;&nbsp;CAMPAIGN REVENUE</span>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4">
        <v-card class="mx-auto rounded-lg mb-5 mt-1" outlined>
          <div class="px-7 py-3">
            <span class="pr-2 font-size-h1 font-weight-bold">{{
              item.total_visits
            }}</span>
            <span class="text-primary">/&nbsp;&nbsp;TOTAL VISITS</span>
          </div>
        </v-card>
        <v-card class="mx-auto rounded-lg mt-5" outlined>
          <div class="px-7 py-3">
            <span class="pr-2 font-size-h1 font-weight-bold">{{
              item.email_sent
            }}</span>
            <span class="text-primary">/&nbsp;&nbsp;EMAIL SENT</span>
          </div>
        </v-card>
      </v-col>
      <!-- <v-col cols="12" sm="12" v-if="item.segments">
        <v-card class="mx-auto rounded-lg mt-n1 mb-n1" outlined>
          <div class="px-3">
            <v-row
              align="center"
              v-if="item.segments && item.segments.length == 0"
            >
              <span class="text-primary ml-4">SEGMENTS</span>
              <v-chip class="ma-2" color="red" outlined>
                Not recorded yet
              </v-chip>
            </v-row>
            <v-row
              align="center"
              v-if="item.segments && item.segments.length > 0"
            >
              <span class="text-primary ml-4">SEGMENTS</span>
              <v-chip
                v-for="(segment, index) in item.segments"
                :key="index"
                class="ma-2"
                :input-value="true"
                filter
                color="success"
                outlined
                small
              >
                {{ segment.name }}
              </v-chip>
            </v-row>
          </div>
        </v-card>
      </v-col> -->
      <v-col cols="12" sm="12">
        <v-card class="mx-auto rounded-lg mb-5" outlined>
          <div class="d-flex justify-content-between pl-3">
            <v-list-item-title class="text-h6 text-uppercase">
              TRANSACTIONS
            </v-list-item-title>
            <v-card-actions class="justify-content-end">
              <!-- <v-btn outlined text small>
              Export
            </v-btn> -->
              <!-- <v-btn outlined text small>
              Unsubscribe
            </v-btn>
            <v-btn outlined text small>
              Remove
            </v-btn> -->
              <div class="input-group">
                <div class="input-group-prepend">
                  <div
                    class="input-group-text"
                    id="btnGroupAddon3"
                    @click="exporItems()"
                    style="cursor:pointer;"
                  >
                    <b-icon icon="cloud-download-fill"></b-icon>
                  </div>
                  <div class="input-group-text" id="btnGroupAddon2">
                    <b-icon icon="search"></b-icon>
                  </div>
                </div>
                <b-form-input
                  v-model="search"
                  placeholder="Search"
                  style="height: auto;"
                ></b-form-input>
              </div>
            </v-card-actions>
          </div>

          <v-list-item>
            <v-list-item-content>
              <div class="tab-content">
                <!--begin::Table-->
                <div class="table-responsive">
                  <TransactionsTable :item="item.payment_tokens" />
                </div>
                <!--end::Table-->
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
.v-window__container {
  background: #eef0f8 !important;
}
</style>
